import { graphql } from "./generated";

export const StakeholderAnswersQuery = graphql(`
  query StakeholderAnswers($termId: ID!) {
    stakeholderAnswers(termId: $termId) {
      answerId
      respondentName
      respondentEmail
      recipientName
      recipientEmail
      stakeholderSettingId
      stakeholderSettingName
      interviewedAt
      scriptSheetUrl
      contentsSheetUrl
      importedAnswerCount
    }
  }
`);

export const ImportStakeholderAnswersMutation = graphql(`
  mutation ImportStakeholderAnswers($answerIds: [ID!]!) {
    importStakeholderAnswers(answerIds: $answerIds) {
      successCount
      failureCount
      results {
        answerId
        success
        errorMessage
      }
    }
  }
`);

export const CreateStakeholderAnswerSheetsMutation = graphql(`
  mutation CreateStakeholderAnswerSheets($termId: ID!) {
    createStakeholderAnswerSheets(termId: $termId) {
      createdCount
      failedCount
      errorMessage
    }
  }
`);
